import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Utils to safely access localStorage
const getStoredUser = () => {
  try {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  } catch {
    return null;
  }
};

const getStoredToken = () => {
  try {
    const user = getStoredUser();
    return user?.token || null;
  } catch {
    return null;
  }
};

// Get API base URL from .env
const API_URL = process.env.REACT_APP_API_URL ;

// Async thunk to login user
export const loginUser = createAsyncThunk(
  'auth/loginUser',
  async ({ userId, password }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/Login`, {
        email: userId, // API expects "email"
        password,
      });
      const { userId: adminUserId, message } = response.data;

      const { token, ...userData } = response.data;

      // Persist to localStorage
      localStorage.setItem('authToken', token);
      localStorage.setItem('adminuserId', adminUserId);

      localStorage.setItem('user', JSON.stringify(userData));

      // Return both user data and token
      return { user: userData, token };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Login failed. Please try again.'
      );
    }
  }
);

// Initial state
const initialState = {
  user: getStoredUser(),
  token: getStoredToken(),
  loading: false,
  error: null,
};

// Auth slice
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user;
        state.token = action.payload.token;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout, setUser } = authSlice.actions;
export default authSlice.reducer;





// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import axios from 'axios';

// const isProduction = process.env.NODE_ENV === 'development';


// // Utils to safely access localStorage
// const getStoredUser = () => {
//   try {
//     if (isProduction && !sessionStorage.getItem('isLoggedIn')) {
//       localStorage.removeItem('user');
//       localStorage.removeItem('authToken');
//       localStorage.removeItem('adminuserId');
//       return null;
//     }
//     const user = localStorage.getItem('user');
//     return user ? JSON.parse(user) : null;
//   } catch {
//     return null;
//   }
// };

// const getStoredToken = () => {
//   // try {
//     const user = getStoredUser();
//   //   return user?.token || null;
//   // } catch {
//   //   return null;
//   // }
//   if (isProduction && !sessionStorage.getItem('isLoggedIn')) return null;
//   return user? localStorage.getItem('authToken') : null;
// };

// // Get API base URL from .env
// const API_URL = process.env.REACT_APP_API_URL ;

// // Async thunk to login user
// export const loginUser = createAsyncThunk(
//   'auth/loginUser',
//   async ({ userId, password }, { rejectWithValue }) => {
//     try {
//       const response = await axios.post(`${API_URL}/Login`, {
//         email: userId, // API expects "email"
//         password,
//       });
//       const { userId: adminUserId } = response.data;

//       const { token, ...userData } = response.data;

//       // Persist to localStorage
//       localStorage.setItem('authToken', token);
//       localStorage.setItem('adminuserId', adminUserId);
//       localStorage.setItem('user', JSON.stringify(userData));
//       sessionStorage.setItem('isLoggedIn', 'true');

//       // Return both user data and token
//       return { user: userData, token };
//     } catch (error) {
//       return rejectWithValue(
//         error.response?.data?.message || 'Login failed. Please try again.'
//       );
//     }
//   }
// );

// // Initial state
// const initialState = {
//   user: getStoredUser(),
//   token: getStoredToken(),
//   loading: false,
//   error: null,
// };

// // Auth slice
// const authSlice = createSlice({
//   name: 'auth',
//   initialState,
//   reducers: {
//     logout: (state) => {
//       state.user = null;
//       state.token = null;
//       sessionStorage.removeItem('isLoggedIn');
//       localStorage.removeItem('user');
//       localStorage.removeItem('authToken');
//       localStorage.removeItem('adminuserId');
//     },
//     setUser: (state, action) => {
//       state.user = action.payload;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(loginUser.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(loginUser.fulfilled, (state, action) => {
//         state.loading = false;
//         state.user = action.payload.user;
//         state.token = action.payload.token;
//       })
//       .addCase(loginUser.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export const { logout, setUser } = authSlice.actions;
// export default authSlice.reducer;